import CampaignIcon from '@mui/icons-material/Campaign'
import MicrosoftSvg from '../../images/icons/bing.png'
import GoogleSearchSvg from '../../images/icons/Google Ads.png'
import GoogleDisplaySvg from '../../images/icons/Google Display.png'
import GoogleIcon from '../../images/icons/googleIcon.svg'
import LinkedInSvg from '../../images/icons/linkedin.svg'
import MetaLightSvg from '../../images/icons/meta_1.svg'
import Seo4Svg from '../../images/icons/seo.png'
import SimplifiSvg from '../../images/icons/simplifi_logo.svg'
import SnapchatSvg from '../../images/icons/snapchat.svg'
import SpotifySvg from '../../images/icons/spotify.svg'
import TikTokSvg from '../../images/icons/tik-tok.png'
import YoutubeSvg from '../../images/icons/youtube.svg'

// Utility function to get the last value from an array, trimmed if needed.
export const getLastItem = (arr: string[]): string => {
  return arr[arr.length - 1]?.trim() || ''
}

export const renderChannelPlatformIcons = (task: any) => {
  const icons = []

  // Helper: Add an icon if a platform matches
  const matchAndPush = (platform: string, iconType: string) => {
    const lower = platform.toLowerCase()
    if (lower.includes('google') && iconType === 'search') {
      icons.push({ label: 'Google Search', icon: GoogleSearchSvg })
    } else if (lower.includes('google') && iconType === 'display') {
      icons.push({ label: 'Google Display', icon: GoogleDisplaySvg })
    } else if (lower.includes('google') && iconType === 'campaign') {
      icons.push({ label: 'Google Campaign', icon: GoogleIcon })
    } else if (iconType === 'Campaign Settings') {
      icons.push({ label: iconType, icon: <CampaignIcon /> })
    } else if (lower.includes('meta')) {
      icons.push({ label: 'Meta', icon: MetaLightSvg })
    } else if (lower.includes('linkedin')) {
      icons.push({ label: 'LinkedIn', icon: LinkedInSvg })
    } else if (lower.includes('microsoft')) {
      icons.push({ label: 'Microsoft', icon: MicrosoftSvg })
    } else if (lower.includes('simplifi')) {
      icons.push({ label: 'Simplifi', icon: SimplifiSvg })
    } else if (lower.includes('snapchat')) {
      icons.push({ label: 'Snapchat', icon: SnapchatSvg })
    } else if (lower.includes('spotify')) {
      icons.push({ label: 'Spotify', icon: SpotifySvg })
    } else if (lower.includes('tiktok')) {
      icons.push({ label: 'TikTok', icon: TikTokSvg })
    } else if (lower.includes('youtube')) {
      icons.push({ label: 'YouTube', icon: YoutubeSvg })
    } else if (lower.includes('seo')) {
      icons.push({ label: 'SEO', icon: Seo4Svg })
    }
  }
  const revisedMatchAndPush = (platform: string, iconType?: string) => {
    const lower = platform.toLowerCase()
    if (lower.includes('search')) {
      icons.push({ label: 'Google Search', icon: GoogleSearchSvg })
    } else if (lower.includes('display')) {
      icons.push({ label: 'Google Display', icon: GoogleDisplaySvg })
    } else if (lower.includes('google campaign')) {
      icons.push({ label: 'Google Campaign', icon: GoogleIcon })
    } else if (iconType === 'Campaign Settings') {
      icons.push({ label: iconType, icon: <CampaignIcon /> })
    } else if (lower.includes('meta')) {
      icons.push({ label: 'Meta', icon: MetaLightSvg })
    } else if (lower.includes('linkedin')) {
      icons.push({ label: 'LinkedIn', icon: LinkedInSvg })
    } else if (lower.includes('microsoft')) {
      icons.push({ label: 'Microsoft', icon: MicrosoftSvg })
    } else if (lower.includes('simplifi')) {
      icons.push({ label: 'Simplifi', icon: SimplifiSvg })
    } else if (lower.includes('snapchat')) {
      icons.push({ label: 'Snapchat', icon: SnapchatSvg })
    } else if (lower.includes('spotify')) {
      icons.push({ label: 'Spotify', icon: SpotifySvg })
    } else if (lower.includes('tiktok')) {
      icons.push({ label: 'TikTok', icon: TikTokSvg })
    } else if (lower.includes('youtube')) {
      icons.push({ label: 'YouTube', icon: YoutubeSvg })
    } else if (lower.includes('seo')) {
      icons.push({ label: 'SEO', icon: Seo4Svg })
    }
  }
  if (task?.channel && !Array.isArray(task?.channel)) revisedMatchAndPush(task?.channel)
  if (task?.platform === 'Meta') revisedMatchAndPush(task?.platform)
  // Check displayPlatform
  if (Array.isArray(task?.displayPlatform)) {
    task.displayPlatform.forEach(platform => matchAndPush(platform, 'display'))
  }

  // Check socialPlatform
  if (Array.isArray(task?.socialPlatform)) {
    task.socialPlatform.forEach(platform => matchAndPush(platform, 'social'))
  }
  // Check socialUpdate
  if (Array.isArray(task?.socialUpdate)) {
    task.socialUpdate.forEach(update => matchAndPush('', update))
  }
  // Check socialCampaignPlatform
  if (Array.isArray(task?.socialCampaignPlatform)) {
    task.socialCampaignPlatform.forEach(platform => matchAndPush(platform, 'campaign'))
  }
  // Check searchCampaignPlatform
  if (Array.isArray(task?.socialCampaignPlatform)) {
    task.searchCampaignPlatform.forEach(platform => matchAndPush(platform, 'campaign'))
  }

  return icons
}
